















































































































import axios from "axios";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { email, minLength, maxLength, required } from "vuelidate/lib/validators";
// @ts-ignore
import { DateTimePicker } from '@hakosalo/datetimepicker';
import Success from "@/modals/Success.vue";
import Error from "@/modals/Error.vue";
import Confirmation from "@/modals/Confirmation.vue";
import serviceRequirement from "@/interfaces/serviceRequirement";

export default Vue.extend({
	components: {
		DateTimePicker,
		Success,
		Error,
		Confirmation
	},
	props: ["uid", "choices", "userCrmUid"],

	data() {
		return {
			muutosValinnat: [] as any,
			serviceRequirementData: {
				tarpeetJaTilanne: "" as string,
				virkailijanLisatiedot: "" as string,
				arviointiPvm: new Date() as Date,
			} as any,
			submitError: '' as string|TranslateResult,
			dateIsValid: true
		};
	},

	validations: {
		serviceRequirementData: {
			tarpeetJaTilanne: {
				maxLength: maxLength(2400)
			},
			virkailijanLisatiedot: {
				maxLength: maxLength(2400)
			}
		}
	},

	created(){
		
	},

	methods: {

		setDateValidity(e: boolean){
			this.dateIsValid = e;
		},

		checkDataAndConfirm(){
			this.$v.$touch()
			if (this.$v.$invalid || !this.dateIsValid) {
				this.submitError = this.$t('submit-error');
				return
			} 
			this.showConfirm();
		},

		saveServiceRequirement(){

			let dataValinnat = this.muutosValinnat.map((valinta: any) => {
				return {
					UID: valinta
				}
			})

			let data: serviceRequirement = this.serviceRequirementData;
			data.tyonhakijaId = this.userCrmUid;
			data.palvelutarpeenArvioinninMuutosValinnat  = dataValinnat;

			axios
				.post("palvelutarpeenarviointi/postServiceRequirement", { ...data })
				.then(() => {
					this.$emit("updateData");
					this.showSuccess();
					// Jos pelkkä this.$refs.success.autoHide() niin antaa virhettä konsolissa jostain syystä.. Varmaan joku ts juttu
					(this.$refs.success as Vue & { autoHide: () => boolean }).autoHide();
				})
				.catch((ex) => {
					console.log(ex);
					this.showError();
					return;
				});
		},

		hideModal() {
			this.$bvModal.hide("service-requirement");
		},

		resetData(){
			this.muutosValinnat = [];
			this.serviceRequirementData = {
				tarpeetJaTilanne: "" as string,
				virkailijanLisatiedot: "" as string,
				arviointiPvm: new Date() as Date
			}
		},

		showSuccess(){
			this.$bvModal.show("success-modal");
		},

		showError(){
			this.$bvModal.show("error-modal");
		},

		showConfirm(){
			this.$bvModal.show("confirmation-modal");
		},

		hideAndResetData(){
			this.hideModal();
			this.resetData();
		}
	}

});
